/**
 * Classifica um save de configurações da sala para não reaplicar mute/câmera
 * quando o usuário só trocou o fundo virtual.
 */

export type SettingsMediaSnapshot = {
  audioEnabled?: boolean;
  videoEnabled?: boolean;
  audioDeviceId?: string;
  videoDeviceId?: string;
  audioOutputDeviceId?: string;
  backgroundType?: unknown;
  virtualBackgroundImagePath?: string | null;
  __source?: string;
};

export type SettingsSaveIntent = 'background-only' | 'media' | 'ignore';

function changed<T>(a: T, b: T): boolean {
  return a !== b;
}

export function classifySettingsSaveIntent(
  previous: SettingsMediaSnapshot,
  next: SettingsMediaSnapshot,
): SettingsSaveIntent {
  if (next.__source === 'device-sync' || next.__source === 'background-apply') {
    return 'ignore';
  }

  const backgroundChanged =
    changed(previous.backgroundType, next.backgroundType) ||
    changed(previous.virtualBackgroundImagePath, next.virtualBackgroundImagePath);

  const deviceChanged =
    changed(previous.audioDeviceId, next.audioDeviceId) ||
    changed(previous.videoDeviceId, next.videoDeviceId) ||
    changed(previous.audioOutputDeviceId, next.audioOutputDeviceId);

  const toggleChanged =
    changed(previous.audioEnabled, next.audioEnabled) ||
    changed(previous.videoEnabled, next.videoEnabled);

  if (backgroundChanged && !deviceChanged && !toggleChanged) {
    return 'background-only';
  }

  return 'media';
}

export function shouldApplyDeviceMediaFromSettings(intent: SettingsSaveIntent): boolean {
  return intent === 'media';
}
